import React, { useState } from "react";
import StatusBadge from "./StatusBadge";

function timeAgo(dateStr) {
  if (!dateStr) return "never";
  const seconds = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}

export default function AgentCard({ agent }) {
  const [modalOpen, setModalOpen] = useState(false);

  const displayText = agent.mcp_prompt || agent.description;

  return (
    <>
      <div className="agent-card" onClick={() => setModalOpen(true)}>
        <div className="agent-card-header">
          <div className="agent-card-identity">
            {agent.avatar_url && (
              <img src={agent.avatar_url} alt="" className="agent-avatar" />
            )}
            <div>
              <span className="agent-name">{agent.name}</span>
              <span className="agent-version">v{agent.version}</span>
            </div>
          </div>
          <StatusBadge status={agent.status} />
        </div>

        {displayText && (
          <p className="agent-description">{displayText}</p>
        )}

        <div className="agent-meta">
          <div className="agent-meta-row">
            <span className="meta-label">Last heartbeat</span>
            <span className="meta-value">{timeAgo(agent.last_heartbeat_at)}</span>
          </div>
          <div className="agent-meta-row">
            <span className="meta-label">Accepting requests</span>
            <span className="meta-value">{agent.accepting_requests ? "Yes" : "No"}</span>
          </div>
          {agent.endpoint && (
            <div className="agent-meta-row">
              <span className="meta-label">Endpoint</span>
              <a href={agent.endpoint} target="_blank" rel="noreferrer" className="meta-value" onClick={(e) => e.stopPropagation()}>
                {agent.endpoint}
              </a>
            </div>
          )}
        </div>

        {agent.tags && agent.tags.length > 0 && (
          <div className="agent-tags">
            {agent.tags.map((t) => (
              <span key={t} className="tag">{t}</span>
            ))}
          </div>
        )}

        {agent.capabilities && agent.capabilities.length > 0 && (
          <div className="agent-capabilities-summary">
            <span className="meta-label">{agent.capabilities.length} capabilities</span>
            <span className="expand-hint">Click for details</span>
          </div>
        )}
      </div>

      {modalOpen && (
        <div className="agent-modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="agent-modal" onClick={(e) => e.stopPropagation()}>
            <button className="agent-modal-close" onClick={() => setModalOpen(false)}>×</button>

            <div className="agent-card-header">
              <div className="agent-card-identity">
                {agent.avatar_url && (
                  <img src={agent.avatar_url} alt="" className="agent-avatar agent-avatar--large" />
                )}
                <div>
                  <span className="agent-name">{agent.name}</span>
                  <span className="agent-version">v{agent.version}</span>
                </div>
              </div>
              <StatusBadge status={agent.status} />
            </div>

            {displayText && (
              <p className="agent-description">{displayText}</p>
            )}

            <div className="agent-meta">
              <div className="agent-meta-row">
                <span className="meta-label">Last heartbeat</span>
                <span className="meta-value">{timeAgo(agent.last_heartbeat_at)}</span>
              </div>
              <div className="agent-meta-row">
                <span className="meta-label">Accepting requests</span>
                <span className="meta-value">{agent.accepting_requests ? "Yes" : "No"}</span>
              </div>
              {agent.endpoint && (
                <div className="agent-meta-row">
                  <span className="meta-label">Endpoint</span>
                  <a href={agent.endpoint} target="_blank" rel="noreferrer" className="meta-value">
                    {agent.endpoint}
                  </a>
                </div>
              )}
            </div>

            {agent.tags && agent.tags.length > 0 && (
              <div className="agent-tags">
                {agent.tags.map((t) => (
                  <span key={t} className="tag">{t}</span>
                ))}
              </div>
            )}

            {agent.capabilities && agent.capabilities.length > 0 && (
              <div className="agent-capabilities">
                <span className="meta-label">Capabilities ({agent.capabilities.length})</span>
                <div className="capability-detail-list">
                  {agent.capabilities.map((c) => (
                    <div key={c.name} className="capability-detail">
                      <span className="capability-name">{c.name}</span>
                      {c.description && <span className="capability-desc">{c.description}</span>}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
